import { render } from "./indexPaymentMethodsComponent.vue?vue&type=template&id=29e4b354"
import script from "./indexPaymentMethodsComponent.vue?vue&type=script&lang=js"
export * from "./indexPaymentMethodsComponent.vue?vue&type=script&lang=js"

import "./indexPaymentMethodsComponent.vue?vue&type=style&index=0&id=29e4b354&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__